/**
* Hreflang helpers for the /pcc/* cluster. Thai canonical is x-default;
* 6 locale mirrors advertised so Google consolidates ranking signals.
*/
const BASE = "https://thainotarylaw.com";
const LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;

export const PCC_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/pcc` },
  ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}/pcc` })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/pcc` },
];

/** Full 7-locale hreflang cluster for a specific PCC service slug. */
export function pccServiceHreflangLinks(slug: string) {
  const p = (loc?: string) => loc ? `/${loc}/pcc/services/${slug}` : `/pcc/services/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${p()}` },
    ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}${p(l)}` })),
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${p()}` },
  ];
}
